import { render, staticRenderFns } from "./FaultsWorkbench.vue?vue&type=template&id=90c288c4&scoped=true&"
import script from "./FaultsWorkbench.vue?vue&type=script&lang=js&"
export * from "./FaultsWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./FaultsWorkbench.vue?vue&type=style&index=0&id=90c288c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c288c4",
  null
  
)

export default component.exports